import React from 'react';
import ReactDOM from 'react-dom';

export default class ScheduleCounterTab extends React.Component {
  constructor(props) {
    super(props);

    this.notificationData = [];

    this.state = {
      notificationData: [],
      popOverActive: false,
      popTarget: null,
    };
  }

  onClickHandler(e) {
    this._onToggleMyPopover();
  }

  _onToggleMyPopover() {
    this.setState({
      popOverActive: !this.state.popOverActive,
      popTarget: ReactDOM.findDOMNode(this),
    });
  }

  dataErrorHandler(collection, response) {
    if (response.responseText) {
      const error = JSON.parse(response.responseText);
      // console.log('api error: ' + error.error_message)
    } else if (response.statusText === 'error') {
      // error handling here
      // console.log('api error: ' + (response.error_message || response.responseText.error_message))
    }
  }

  componentWillUnmount() {}

  render() {}
}
